import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { AttachedEntities } from '@app/domain/types';

@Component({
	selector: 'attached-entity-card',
	imports: [MatCardModule, MatIconModule, MatCheckboxModule],
	templateUrl: './attached-entity-card.component.html',
	styleUrls: ['./attached-entity-card.component.scss', '../../styles/entity-tabs.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttachedEntityCardComponent {
	entity = input<{ type: string; data: AttachedEntities }>();
	selectedEntityPks = input<string[] | null>(null);
	isSelected = output<[boolean, AttachedEntities]>();
}
